// @ts-ignore
import * as zhTWJSON from './zh-TW.json';

export default {
  ...zhTWJSON,
};
